import protoRoot from "../proto-root";
import createMessage from "./createMessage";

const name = "setVideoFlashlightMessage";

function create({ enabled, intensity }) {
  const SetVideoFlashlightMessage = protoRoot.lookupType(
    `comm.SetVideoFlashlightMessage`
  );

  return createMessage({
    [name]: SetVideoFlashlightMessage.create({
      enabled,
      intensity
    })
  });
}

export default {
  create,
  name
};

// message SetVideoFlashlightMessage {
//     bool enabled = 1;
//     float intensity = 2;
// }
